/**
 * PraticaTimeline — F-005 Phase 4 (IMPL-P4-004).
 *
 * Cronologia eventi per la pagina di dettaglio pratica. Renderizza una
 * `<section aria-label>` con `<ol>` ordinata cronologicamente; delega
 * il rendering del singolo evento a `PraticaTimelineItem`.
 *
 * Eventi sono già pre-ordinati lato server (createdAt ASC, vedi Phase 2).
 */
import type { PraticaDetailResponse } from '../lib/cliente-pratiche-client';
import { PraticaTimelineItem } from './PraticaTimelineItem';

interface PraticaTimelineProps {
  events: PraticaDetailResponse['timeline'];
}

export function PraticaTimeline({ events }: PraticaTimelineProps) {
  if (events.length === 0) return null;
  return (
    <section aria-label="Cronologia pratica">
      <h2 className="mb-3 text-base font-semibold">Cronologia</h2>
      <ol className="relative space-y-4 border-l border-gray-200 pl-6">
        {events.map((ev) => (
          <PraticaTimelineItem key={ev.id} event={ev} />
        ))}
      </ol>
    </section>
  );
}
